<template>
  <WizardButton
    wizard-api-url="/api/wizard/damage-report"
    color="link"
    class="text-black me-6 flex-column"
  >
    <template #title>
      <span class="fs-xsmall mb-1 w-100 text-start">
        {{ $t('Online') }}
      </span>
      <span class="fw-bolder fs-normal text-black w-100 text-start">
        {{ $t('Hlásenie škody') }}
      </span>
    </template>
  </WizardButton>
</template>
